import { createAsyncThunkFromFetch } from 'src/store/utils';
import {
  GetBillingParams,
  GetHeadsetBillingResponse,
  GetPackageBillingResponse,
} from './companyBilling.types';
import { getHeadsetsBilling, getPackagesBilling } from './companyBilling.api';

const prefix = 'companyBilling';

export const fetchHeadsetsBillingAction = createAsyncThunkFromFetch<
  GetHeadsetBillingResponse,
  {
    companyId: string;
    params?: GetBillingParams;
  }
>(`${prefix}/fetchHeadsetsBilling`, getHeadsetsBilling);

export const fetchPackagesBillingAction = createAsyncThunkFromFetch<
  GetPackageBillingResponse,
  {
    companyId: string;
    params?: GetBillingParams;
  }
>(`${prefix}/fetchPackagesBilling`, getPackagesBilling);
